enum Action {
  APPROVE = 'approve',
  DECLINE = 'decline',
  GET_ABSENCE_DURATION = 'getAbsenceDuration',
  UPLOAD_ATTACHMENT = 'uploadAttachment',
  GET_CALENDAR_AGGREGATIONS = 'getCalendarAggregations',
}

export default Action;
